import * as selectedTermSelectors from './selectedTermSelectors';
import { calculateVehicleProtectionSummary, isVppProductSelected } from '../utils/vehicleProtectionUtils';
import { getCurrentOfferType } from './offerNodeSelectors';
import * as paymentSelectors from './paymentSelectors';
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';

// Sales View | AMD
export const getVppProducts = (state: OfferReduxBaseState) => {
    if (!state.vehicleProtection && !state.vehicleProtectionV2) {
        return [];
    }

    return state.vehicleProtection?.protectionObjList || state.vehicleProtectionV2.products || [];
};

export const getVppSelectedProducts = (state: OfferReduxBaseState) => {
    return getVppProducts(state).filter(isVppProductSelected);
};

export const isPaymentFailed = (state: OfferReduxBaseState): boolean => {
    return state.vehicleProtection?.isPaymentFailed || state.vehicleProtectionV2?.isPaymentFailed || false;
};

export const areFeatureTogglesAvailable = (state: OfferReduxBaseState): boolean => !!state?.featureToggles;

export const usePaymentProductsMonthlyPayment = (state: OfferReduxBaseState): boolean =>
    !!state?.featureToggles?.usePaymentProductsMonthlyPayment;

export const getVppSummary = (state: OfferReduxBaseState) => {
    const currentOfferType = getCurrentOfferType(state);
    const availableProducts = getVppProducts(state).filter(
        (product: any) => product.offerTypes?.includes(currentOfferType) ?? true
    );

    const term = selectedTermSelectors.getSelectedTermMonths(state);
    const calculatedSummary = calculateVehicleProtectionSummary({ products: availableProducts, term });
    const areFeatureTogglesAvailableFlag = areFeatureTogglesAvailable(state);

    // NOTE: if toggle is turned on - use PO monthly payment of each individual product whatever it's possible
    if (areFeatureTogglesAvailableFlag && usePaymentProductsMonthlyPayment(state)) {
        const isCalculatingPayment = paymentSelectors.isCalculatingPayment(state);

        if (!isPaymentFailed(state) && !isCalculatingPayment) {
            calculatedSummary.productMonthlyPayment = getVppSelectedProducts(state)
                .filter((product: any) => product.offerTypes?.includes(currentOfferType) ?? true)
                .reduce((totalMonthlyPayment: number, product: any) => {
                    const productPrice = product.totalPrice || product.productPrice;
                    const monthlyPayment = product.monthlyPrice || product.productMonthlyPayment;
                    const defaultMonthlyPayment = productPrice && term ? productPrice / term : 0;
                    const productMonthlyPayment = monthlyPayment ?? defaultMonthlyPayment;

                    return totalMonthlyPayment + productMonthlyPayment;
                }, 0);
        }
    }

    return calculatedSummary;
};
